import { FC, PropsWithChildren } from 'react';

const GeneralTab: FC<PropsWithChildren> = ({ children }) => {
  return <>{children}</>;
};

export default GeneralTab;
